import { render, staticRenderFns } from "./ImageGroup.vue?vue&type=template&id=5d5e5bfa&scoped=true&"
import script from "./ImageGroup.vue?vue&type=script&lang=js&"
export * from "./ImageGroup.vue?vue&type=script&lang=js&"
import style0 from "./ImageGroup.vue?vue&type=style&index=0&id=5d5e5bfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e5bfa",
  null
  
)

export default component.exports